import AuthLayout from '@/layouts/AuthLayout.vue';
import guest from '@/middleware/guest';
import type { Middleware } from '@/types/router';
import { AuthRouteName } from '@/types/router/name/auth';
import { AuthRoutePath } from '@/types/router/path/auth';

export default [
    {
        path: AuthRoutePath.Login,
        name: AuthRouteName.Login,
        component: () => import('@/pages/auth/login/index.vue'),
        meta: {
            group: 'login',
            title: 'Login',
            layout: AuthLayout,
            middleware: [guest] as Middleware[]
        }
    }
];
